/**
 * Generate a fresh UUID v4.
 */
function generateUUID() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
        return crypto.randomUUID();
    }
    // Fallback for older browsers.
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

/**
 * Read a cookie value by name.
 */
function getCookie(name) {
    const match = document.cookie.match(new RegExp('(?:^|;\\s*)' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
}

/**
 * Called right before Freemius checkout opens.
 * - Generates a fresh tracker_id (always new per checkout attempt)
 * - Reads UTM from current URL (last-click)
 * - Reads FB cookies
 * - POSTs tracker_id + UTM data to our server (fire-and-forget)
 *
 * Returns the tracker_id to be passed directly to FS.Checkout.open().
 * Freemius webhook will send back the tracker_id so server can match UTM data.
 *
 * @returns {string} tracker_id
 */
export function trackBeforeCheckout() {
    const serverUrl = window['JkitDashboardOption']?.serverUrl;
    const trackerId = generateUUID();

    const urlParams = new URLSearchParams(window.location.search);
    const utm = {
        utm_source: urlParams.get('utm_source') || '',
        utm_medium: urlParams.get('utm_medium') || '',
        utm_campaign: urlParams.get('utm_campaign') || '',
    };

    const fbp = getCookie('_fbp');
    const fbc = getCookie('_fbc');
    const freemiusConfig = window['JkitDashboardOption']?.freemius?.pricing;

    // Prefer same-origin proxy endpoint to avoid exposing external server URL and CORS issues
    const proxyEndpoint = '/wp-json/jkit/v1/utm-proxy/';
    // Prefer WP REST nonce for cookie-based REST authentication
    const nonce = window['JkitDashboardOption']?.wpRestNonce || '';

    fetch(proxyEndpoint, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-WP-Nonce': nonce },
        body: JSON.stringify({
            tracker_id: trackerId,
            utm_source: utm.utm_source,
            utm_medium: utm.utm_medium,
            utm_campaign: utm.utm_campaign,
            utm_client_site: freemiusConfig?.client_site || window.location.hostname,
            utm_client_theme: freemiusConfig?.client_theme || '',
            _fbp: fbp,
            _fbc: fbc,
        }),
    }).catch(() => { /* fire-and-forget */ });

    return trackerId;
}
